module.exports = __webpack_public_path__ + "dscout-private-panels-logo.svg";